module.exports = __webpack_public_path__ + "static/img/fanhui_btn.d6c11d33.png";